<template>
  <div>
    <home-nav-bar :title="title">
      <template #left>
        <router-link :to="{ name: 'PickRecord', query: { landId: landId }}">
          <van-icon name="arrow-left" />
        </router-link>
      </template>
    </home-nav-bar>
    <div class="primary">
      <van-cell class="cell-item" is-link value="已完善" @click="popup.pickInfo.show = true">
        <template #title>
          <svg-icon icon-class="crop" class="icon" /><span class="label">产品信息</span>
        </template>
      </van-cell>
      <van-cell class="cell-item" is-link :value="completeText(form.inspectCertInfoJSON, 1)" @click="popup.testReport.show = true">
        <template #title>
          <svg-icon icon-class="microscope" class="icon" /><span class="label">权威检测(至少添加一项)</span>
        </template>
      </van-cell>
      <div class="cell-item land-info">
        <van-icon name="location-o" class="icon" /><span class="label">产地信息</span>
        <wh-map-draw
          v-if="form.land.latLng"
          style="width: 100%;height: 200px;"
          class="land-map"
          :editable="false"
          :geometry-j-s-o-n="form.land.latLng"
        />
        <div v-else class="map-empty">
          暂未绘制地块地图
        </div>
        <van-cell
          :user-id="userId"
          class="cell-item"
          title="摄像头"
          value-class="wh-primary-text"
          :value="popup.camera.deviceLength ? '已绑定' : '未绑定'"
          is-link
          @click="popup.camera.deviceLength ? null : popup.camera.show = true "
        />
        <trace-device-status
          :user-id="userId"
          :visible.sync="popup.camera.show"
          device-type="camera"
          :device-length.sync="popup.camera.deviceLength"
        />
        <van-cell
          class="cell-item"
          title="传感器"
          is-link
          value-class="wh-primary-text"
          :value="popup.camera.deviceLength ? '已绑定' : '未绑定'"
          @click="popup.iot.deviceLength ? null : popup.iot.show = true "
        />
        <trace-device-status
          :user-id="userId"
          :visible.sync="popup.iot.show"
          device-type="iot"
          :device-length.sync="popup.iot.deviceLength"
        />
      </div>
      <van-cell class="cell-item" is-link value="建议5条以上" @click="popup.farmWorkRecords.show = true">
        <template #title>
          <svg-icon icon-class="shovel" class="icon" /><span class="label">种植环节({{ farmWorkRecordsSelected }})</span>
        </template>
      </van-cell>
    </div>
    <div class="submit-box">
      <van-button class="submit" round type="info" @click="submit">
        {{ formType === 'create' ? '创建' : '更新' }}并查看溯源
      </van-button>
    </div>
    <pick-info-popup :visible.sync="popup.pickInfo.show" :form="form" />
    <test-report-list-popup :visible.sync="popup.testReport.show" :test-report-list="form.inspectCertInfoJSON" />
    <farm-work-trace-popup :visible.sync="popup.farmWorkRecords.show" :farm-work-records="form.farmWorkJSON" />
  </div>
</template>

<script>
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import { traceDataByTraceCode } from '@/utils/mixins/traceDataByTraceCode'
import PickInfoPopup from '@/views/productManage/TraceSource/TraceSourceEditor/PickInfoPopup'
import TestReportListPopup from '@/views/productManage/TraceSource/TraceSourceEditor/TestReportListPopup'
import WhMapDraw from '@/components/public/WhMapDraw/WhMapDraw'
import FarmWorkTracePopup from '@/views/productManage/TraceSource/TraceSourceEditor/FarmWorkTracePopup'
import api from '@/api'
import TraceDeviceStatus from '@/views/productManage/TraceSource/components/TraceDeviceStatus'
import { initObjData } from '@/utils/tool'
import { formatTime } from '@/utils/convert/convertTime'
import { UPLOAD_CONFIG } from '@/constant/config'

export default {
  name: 'TraceSourceEditor',
  components: { TraceDeviceStatus, FarmWorkTracePopup, WhMapDraw, TestReportListPopup, PickInfoPopup, HomeNavBar },
  mixins: [traceDataByTraceCode],
  props: {
    formType: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      popup: {
        pickInfo: {
          show: false
        },
        testReport: {
          show: false
        },
        farmWorkRecords: {
          show: false
        },
        camera: {
          show: false,
          deviceLength: 0
        },
        iot: {
          show: false,
          deviceLength: 0
        }
      },
      form: {
        id: undefined,
        traceCode: undefined,
        productName: '',
        productCropType: '',
        productPlantStandard: undefined,
        productPickTime: undefined,
        productPic: '',
        farmWorkJSON: [
          {
            farmWork: undefined,
            agriculturalName: undefined,
            agriculturalDosage: undefined,
            staffName: undefined
          }
        ],
        inspectCertInfoJSON: [],
        cameraUrl: undefined,
        sensorId: undefined,
        landId: '',
        land: {},
        company: {},
        companyId: undefined,
        logisticCompany: undefined,
        logisticCode: undefined
      }
    }
  },
  computed: {
    title() {
      if (this.type === 'create') {
        return '创建溯源'
      } else if (this.type === 'edit') {
        return '编辑溯源'
      }
      return '溯源'
    },
    farmWorkRecordsSelected() {
      return this.form.farmWorkJSON.filter(item => {
        return item.notChange || item.selected
      }).length
    },
    userId() {
      return this.$store.getters.userData.id
    }
  },
  watch: {
    traceData: { // 溯源所有信息获取成功后初始化表单
      handler(newVal) {
        if (newVal) {
          let inspectCertInfoJSON = newVal.inspectCertInfoJSON
          if (!inspectCertInfoJSON.length) {
            inspectCertInfoJSON = newVal.controlInspectReport || []
          }
          initObjData(this.form, {
            ...newVal,
            inspectCertInfoJSON,
            productPickTime: formatTime(newVal.productPickTime),
            companyId: this.$store.getters.companyId
          })
        }
      }
    }
  },
  methods: {
    /**
     * 判断对象所有属性不为空比例 0-100
     * @param obj {Object, Array}
     * @param minLength {Number} 有效最小元素个数
     * @returns {Number}
     */
    complete(obj, minLength = -1) {
      let done = 100
      let length = 1
      if (obj) {
        if (obj.constructor === Object) {
          length = Object.keys(obj).length
          if (length) {
            let count = 0
            for (const key in obj) {
              if (![undefined, null, ''].includes(obj[key])) {
                count++
              }
            }
            done = Math.round((count * 100) / length)
          }
        } else if (obj.constructor === Array) {
          length = obj.length
          if (length < minLength) {
            done = Math.round((length * 100) / minLength)
          }
        }
      }
      return done
    },
    completeText(obj, minLength = -1, doneText = '已完善') {
      const done = this.complete(obj, minLength)
      return done === 100 ? doneText : `${this.complete(obj, minLength)}%`
    },
    submit() {
      this.form.traceCode = this.traceCode

      const inspectCertInfoJSON = this.form.inspectCertInfoJSON.filter(item => item.reportName).map(listItem => {
        listItem.pic = listItem.pic.map(item => { // 对图片相关数据进行处理
          let url = item.url
          let urlThumbnail = item.urlThumbnail
          if (/^blob:http:/.test(item.url)) {
            url = `${UPLOAD_CONFIG.fetchUrl}${item.key}` // 转换为线上地址存储
            urlThumbnail = `${UPLOAD_CONFIG.fetchUrl}${item.key}?imageView2/1/w/100/h/100/q/75|imageslim`
          }
          return {
            key: item.key,
            url: url,
            urlThumbnail,
            name: item.name
          }
        })
        return listItem
      })

      api.updateControlProductTrace({
        ...this.form,
        inspectCertInfoJSON: inspectCertInfoJSON,
        farmWorkJSON: this.form.farmWorkJSON
      }).then(res => {
        this.$router.push({
          name: 'TraceSource',
          query: {
            traceCode: this.traceCode
          }
        })
      })
    }
  }
}
</script>

<style lang='less' scoped>
.primary {
  .cell-item {
    padding: 10px 16px;
    background: #ffffff;
    font-size: 14px;
    color: #323233;
    word-break: keep-all;
    white-space: nowrap;
    .icon {
      color: black;
    }
    .label {
      margin-left: 6px;
    }
    &.land-info {
      .land-map {
        margin-top: 10px;
      }
      .map-empty {
        font-size: 20px;
        font-weight: bold;
        color: #cccccc;
        text-align: center;
        line-height: 50px;
      }
    }
  }

}
.submit-box {
  @height: 40px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .submit {
    height: @height - 20px;
    width: 200px;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 10px auto;

    padding: 20px 0 20px 0;
  }
}
</style>
